export default __webpack_public_path__ + "static/media/badIcon.352fd2e2.svg";